// extracted by mini-css-extract-plugin
export default {"formTitle":"Q49vai","button":"ygeQpc","priceInput":"t93dbt"};